import React from 'react';

interface AvatarProps {
    name: string;
    size?: 'xs' | 'sm' | 'md';
    className?: string;
}

const sizeMap = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base'
};

export function Avatar({ name, size = 'md', className = '' }: AvatarProps) {
    // Get initials from name (first letter of first two words)
    const getInitials = (name: string) => {
        const words = name.trim().split(/\s+/);
        if (words.length === 1) {
            return words[0].substring(0, 2).toUpperCase();
        }
        return (words[0][0] + words[1][0]).toUpperCase();
    };

    // Generate consistent color from name
    const getColorFromName = (name: string) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = hash % 360;
        return `hsl(${hue}, 65%, 55%)`;
    };

    const initials = getInitials(name);
    const bgColor = getColorFromName(name);

    return (
        <div
            className={`${sizeMap[size]} rounded-full flex items-center justify-center font-semibold text-white flex-shrink-0 ${className}`}
            style={{ backgroundColor: bgColor }}
            title={name}
        >
            {initials}
        </div>
    );
}
